import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  static targets = ['frame']
  static values = {
    origins: { type: Array, default: [] },
    messageType: String
  }

  connect () {
    this.handleMessage = this.handleMessage.bind(this)
    window.addEventListener('message', this.handleMessage)
  }

  disconnect () {
    window.removeEventListener('message', this.handleMessage)
  }

  handleMessage (event) {
    if (!this.originsValue.includes(event.origin)) return
    if (!this.hasFrameTarget || event.source !== this.frameTarget.contentWindow) return
    if (event.data?.type !== this.messageTypeValue) return

    Turbo.visit(window.location.href, { action: 'replace' })
  }
}
